export default __webpack_public_path__ + "static/media/notewrote4.be98cef3.jpg";